import { GameMapControl } from "lib/gamemap/GameMapControl";
import ControlWithHeader from "./ControlWithHeader";
export default class InteractionTopControl extends GameMapControl {
    constructor(_config = {}) {
        super({
            type: "gapless",
            position: "top-center"
        }, new ControlWithHeader(_config.name ?? "Interaction", _config.cancel_handler));
        this._config = _config;
        this.content.addClass("ctr-interaction-control");
    }
    setCancelHandler(f) {
        this._config.cancel_handler = f;
        this.content.header.close_handler.set(f);
        return this;
    }
    setName(name) {
        this.content.header.name.set(name);
        return this;
    }
    setContent(widget) {
        this.content.setContent(widget);
        return this;
    }
    setText(text) {
        return this.setContent(c().text(text));
    }
    eventKeyDown(event) {
        if (this._config.cancel_handler) {
            event.onPre(() => {
                if (event.original.key == "Escape") {
                    event.stopAllPropagation();
                    this._config.cancel_handler();
                }
            });
        }
    }
}
